import "oj-event";
import m from "mithril";
import { delegate, pause } from "oj-promise-utils";
import { cleanString, increment } from "oj-utils";
import { createAnimation } from "../../utils/animation/animation";
import "./dialog.scss";
import { Svg } from "../svg/svg";
import { getAsset } from "../../utils/utils";
import { getTextFixed } from "../../state/translations";
import { trapFocus } from "../../utils/accessibility";
const inc = increment();
let container;
// let openCount = 0
// const lockScroll = () => {
//   if (openCount++ === 0)
//     document.body.style.overflow = "hidden"
// }
// const unlockScroll = () => {
//   if (--openCount <= 0) {
//     openCount = 0
//     document.body.style.overflow = ""
//   }
// }
export const dialog = (options, component, targetFocus, currentFocus = document.activeElement) => {
    container ??= document.body.querySelector(".oj-App");
    const id = inc();
    const d = delegate();
    const div = document.createElement("div");
    const animate = createAnimation();
    let root;
    let inner;
    let header;
    let content;
    let closed;
    let ro;
    let trap;
    let _open = false;
    const applyStyles = (el, styles) => {
        Object.assign(el.style, styles);
    };
    const applyAnimation = ({ a, y, x, width, height }) => {
        applyStyles(root, {
            opacity: `${a}`
        });
        if (options.morph) {
            const styles = {
                left: `${x}px`,
                top: `${y}px`,
                width: `${width}px`,
                minWidth: `${width}px`,
                maxWidth: `${width}px`,
                height: `${height}px`,
                minHeight: `${height}px`,
                maxHeight: `${height}px`
            };
            applyStyles(inner, styles);
        }
        else
            applyStyles(inner, {
                transform: `translateY(${y}px)`
            });
    };
    const getMorphIn = () => {
        if (!options.morph)
            return;
        if (Array.isArray(options.morph))
            return options.morph;
        if (typeof options.morph === "function")
            return options.morph(true);
    };
    const getMorphOut = () => {
        if (!options.morph)
            return;
        if (Array.isArray(options.morph))
            return [...options.morph].reverse();
        if (typeof options.morph === "function")
            return [...options.morph(false)].reverse();
    };
    const oncreate = async (v) => {
        await options.onbeforeopen?.();
        root = v.dom;
        header = root.querySelector(".oj-header");
        content = root.querySelector(".oj-content");
        inner = root.firstElementChild;
        container ??= document.body.querySelector(".oj-App");
        container.appendChild(root);
        const _animation = animate({
            onupdate: applyAnimation,
            onstart: () => {
                if (options.morph) {
                    const [morphStart, morphEnd] = getMorphIn();
                    if (header)
                        applyStyles(header, {
                            width: `${morphEnd.width}px`
                        });
                    if (content)
                        applyStyles(content, {
                            width: `${morphEnd.width}px`,
                        });
                    return [
                        [{ a: { from: 0, to: 1 } }, { delay: 100, duration: 200, easing: "easeOutSine" }],
                        [
                            {
                                x: { from: morphStart.x, to: morphEnd.x },
                                y: { from: morphStart.y, to: morphEnd.y },
                                width: { from: morphStart.width, to: morphEnd.width },
                                height: { from: morphStart.height, to: morphEnd.height },
                            },
                            { duration: 300, easing: "easeOutSine" },
                        ],
                    ];
                }
                return [
                    [{ a: { from: 0, to: 1 } }, { duration: 200, easing: "easeOutSine" }],
                    [{ y: { from: -48, to: 0 } }, { duration: 200, easing: "easeOutSine" }],
                ];
            },
            onstop: () => {
                if (header)
                    applyStyles(header, {
                        width: `100%`
                    });
                if (content)
                    applyStyles(content, {
                        width: `100%`
                    });
            }
        });
        _animation.promise.then(() => {
            ro = new ResizeObserver(() => {
                if (typeof options.morph === "function") {
                    const morphEnd = options.morph(undefined)?.[1];
                    const morphStart = inner.getBoundingClientRect();
                    animate({
                        onupdate: applyAnimation,
                        onstart: () => [
                            [{
                                    x: { from: morphStart.x, to: morphEnd.x },
                                    y: { from: morphStart.y, to: morphEnd.y },
                                    width: { from: morphStart.width, to: morphEnd.width },
                                    height: { from: morphStart.height, to: morphEnd.height },
                                },
                                { duration: 0 },
                            ]
                        ]
                    });
                }
            });
            ro.observe(document.body);
        });
        trap = trapFocus(inner, targetFocus, (currentFocus || document.activeElement));
        trap.promise.then(() => close());
        window.on(`keydown.Dialog.${id}`, e => {
            if (e.key === "Escape")
                if (typeof options.dismiss === "function" ? options.dismiss() : (options.dismiss ?? true))
                    close();
        });
        // lockScroll()
        pause(100).promise.then(() => {
            _open = true;
        });
        options.onopen?.({ close });
    };
    const onremove = v => {
        window.off(`keyup.Dialog.${id}`);
        container.removeChild(root);
        ro?.disconnect();
    };
    const close = async (event = "dismiss") => {
        if (closed)
            return;
        trap?.off();
        _open = false;
        await options.onbeforeclose?.(event);
        closed = true;
        d.resolve(event);
        await animate({
            onupdate: applyAnimation,
            onstart: () => {
                if (options.morph) {
                    const [morphStart, morphEnd] = getMorphOut();
                    return [
                        [{ a: { from: 1, to: 0 } }, { duration: 200, easing: "easeOutSine" }],
                        [
                            {
                                x: { from: morphStart.x, to: morphEnd.x },
                                y: { from: morphStart.y, to: morphEnd.y },
                                width: { from: morphStart.width, to: morphEnd.width },
                                height: { from: morphStart.height, to: morphEnd.height },
                            },
                            { duration: 300, easing: "easeOutSine" },
                        ],
                    ];
                }
                return [
                    [{ a: { from: 1, to: 0 } }, { duration: 200, easing: "easeOutSine" }],
                    [{ y: { from: 0, to: 48 } }, { duration: 200, easing: "easeOutSine" }],
                ];
            },
        }).promise;
        // unlockScroll()
        try {
            m.mount(div, null);
        }
        catch { }
        options.onclose?.(event);
    };
    const view = v => m("div", { className: cleanString("oj-AppDialog", options.className, (options.backdrop ?? true) && "backdrop"), onclick: (typeof options.dismiss === "function" ? options.dismiss() : (options.dismiss ?? true)) ? close : undefined },
        m("div", { onclick: e => {
                e.stopPropagation();
            } },
            options.title && m("div", { className: "oj-header" },
                m("div", null,
                    m("div", null,
                        m("span", { className: "title" }, typeof options.title === "function" ? options.title() : options.title),
                        options.subtitle && m("span", { className: "fs6" }, typeof options.subtitle === "function" ? options.subtitle() : options.subtitle)),
                    (typeof options.close === "function" ? options.close() : (options.close ?? true)) &&
                        m("button", { className: cleanString("close", options.closeIcon && "icon-only"), onclick: e => {
                                if (_open) {
                                    close();
                                }
                            } }, options.closeIcon
                            ? m(Svg, { className: "icon", src: getAsset("icons/close.svg") })
                            : m("span", null, getTextFixed("CLOSE"))))),
            m("div", { className: "oj-content" }, component(close))));
    m.mount(div, { view, oncreate, onremove });
    return {
        promise: d.promise,
        close
    };
};
